import React, { useEffect, useState } from 'react';
import { Checkbox, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { JudgeSettingItem, JudgeAutoSettingItem, SetJusgeAutoSetting } from './JudgeSetting';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import NumericEntry from '../../../atoms/Input/NumericEntry';
import { TableBaseStyle } from './JudgeSettingStyle';
import { PLCcollectSettingType } from '../CollectSetting/CollectSettingDefine';
import { JdgTypKind, AlmTypKind, MeasureClcType, CcTypKind, MOVING_AVERAGE_METHOD } from '../../../../Constant';
import NumericEntry_inputEx from './../../../atoms/Input/NumericEntry_inputEx';
import { MST_CLC_TYP } from '../../../../function/MstClcTypModels';
import { ALM_KIND_SET } from '../../../../function/AlmKindSetModel';
import { JudgeSettingSelectType } from '../../../../function/JudgeSettingSelectModel';

type CLC_TYP_SET = {
  TYP_NO: number;
  TYP_NAME: string;
  TYP_INVALID: number;
};
type JudgeSettingItemRowProps = {
  judgeSettingItem: JudgeSettingItem;
  judgeAutoSettings: JudgeAutoSettingItem[];
  judgeItemSelectInfo: JudgeSettingSelectType[]; //各選択項目の情報
  plcCollectSetting: PLCcollectSettingType;
  onChangeData: (item: JudgeSettingItem) => void;
  mclcTypeCombos: ComboBoxItemType[];
  jdgCombos: ComboBoxItemType[];
  clcCombos: ComboBoxItemType[];
  almCombos: ComboBoxItemType[];
};

const JudgeSettingItemRow: React.FC<JudgeSettingItemRowProps> = (props: JudgeSettingItemRowProps) => {
  const tableBaseStyle = TableBaseStyle();
  const [judgeSet, setJudgeSet] = useState<JudgeSettingItem>(props.judgeSettingItem);

  //console.debug(['★JudgeSettingItemRow - props, judgeSet', props, judgeSet]);

  /**
   * 演算種別アイテム取得
   * @returns
   */
  const mclcTypeFilterCombos = (): ComboBoxItemType[] => {
    console.debug(['演算種別アイテム取得', props.judgeItemSelectInfo, props.mclcTypeCombos]);
    if (judgeSet.CHANGE_INVALID === 1) {
      return props.mclcTypeCombos.filter((r) => {
        if (r.index === 0 || props.judgeItemSelectInfo.findIndex((rr) => judgeSet.MCLC_TYP_ID === r.index) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      return props.mclcTypeCombos.filter((r) => {
        //移動平均法はコンボボックスに表示しない
        if (r.index !== MOVING_AVERAGE_METHOD) {
          if (r.index === 0 || props.judgeItemSelectInfo.findIndex((rr) => rr.MCLC_TYP_ID === r.index) !== -1) {
            return true;
          } else {
            return false;
          }
        }
      });
    }
  };

  /**
   * 診断タイプ選択アイテム取得
   * @returns
   */
  const jdgFilterCombos = (): ComboBoxItemType[] => {
    //console.debug(['選択候補リスト情報', props.judgeItemSelectInfo]);
    if (judgeSet.CHANGE_INVALID === 1) {
      return props.jdgCombos.filter((r) => {
        if (r.index === 0 || props.judgeItemSelectInfo.findIndex((rr) => judgeSet.JDG_TYP === r.index) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      const jdgList = props.judgeItemSelectInfo.filter((r) => r.MCLC_TYP_ID === judgeSet.MCLC_TYP_ID);
      return props.jdgCombos.filter((r) => {
        if (r.index === 0 || jdgList.findIndex((rr) => rr.TYP_NO_JDG === r.index) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    }
  };

  /**
   * 演算方法選択アイテム取得
   * @returns
   */
  const clcFilterFCombos = (): ComboBoxItemType[] => {
    //console.debug(['演算方法リスト', props.clcCombos]);
    if (judgeSet.CHANGE_INVALID === 1) {
      return props.clcCombos;
    } else {
      let clcf = props.clcCombos.filter((r) => {
        let v = r.tag as CLC_TYP_SET;
        if (v) {
          if (v.TYP_INVALID === 0 || v.TYP_INVALID === null) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
      //console.debug(['演算方法リスト2', props.clcCombos, clcf, judgeSet]);

      const clcList = props.judgeItemSelectInfo.filter(
        (r) => r.MCLC_TYP_ID === judgeSet.MCLC_TYP_ID && r.TYP_NO_JDG === judgeSet.JDG_TYP
      );
      //console.debug(['演算方法リスト3', props.clcCombos, clcList]);
      return clcf.filter((r) => {
        if (r.index === 0 || clcList.findIndex((rr) => rr.TYP_NO_CLC === r.index) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    }
  };

  /**
   * 異常種別選択アイテム取得
   * @returns
   */
  const almFilterCombos = (): ComboBoxItemType[] => {
    //console.debug(['異常種別選択アイテム1', props.almCombos]);
    return props.almCombos.filter((r) => {
      let alm = r.tag as ALM_KIND_SET;
      //console.debug(['異常種別選択アイテム3', alm]);
      if (r.index === 0 || alm.MCLC_TYP_ID === judgeSet.MCLC_TYP_ID) {
        return true;
      } else {
        return false;
      }
    });
  };

  useEffect(() => {
    setJudgeSet({ ...props.judgeSettingItem });
  }, [props.judgeSettingItem]);

  /**
   * JudgeSetObjectを更新する汎用関数
   * @param key
   * @param value
   */
  const onChangeCell = <K extends keyof JudgeSettingItem, V extends JudgeSettingItem[K]>(key: K, value: V) => {
    let tmp = { ...judgeSet, [key]: value };
    setJudgeSet(tmp);
    console.debug(['onChangeCell - old,new', judgeSet, tmp]);
    props.onChangeData(tmp);
  };
  /**
   * 値を変更すると、自動で、重故障軽故障の内容を変える
   * @param key
   * @param value
   */
  const onChangeCellAutoValue = <K extends keyof JudgeSettingItem, V extends JudgeSettingItem[K]>(key: K, value: V) => {
    let tmp = { ...judgeSet, [key]: value };
    let autoValue = SetJusgeAutoSetting(tmp, props.judgeAutoSettings, props.plcCollectSetting);
    if (autoValue.ALM_LIM !== null && autoValue.WRN_LIM !== null) {
      tmp.ALM_LIM = autoValue.ALM_LIM;
      tmp.WRN_LIM = autoValue.WRN_LIM;
    }
    setJudgeSet(tmp);
    console.debug(['onChangeCell - old,new', judgeSet, tmp]);
    props.onChangeData(tmp);
  };

  /**
   * 周波数
   * @returns
   */
  const freq_c_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else if (judgeSet.CHANGE_INVALID === 1) {
      return <>{judgeSet.FREQ_C.toFixed(4)}</>;
    } else if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均は周波数不使用
      return null;
    } else if (judgeSet.JDG_TYP !== JdgTypKind.RAW) {
      return (
        <>
          <NumericEntry_inputEx
            className={tableBaseStyle.textField}
            value={judgeSet.FREQ_C}
            fixed={4}
            onChange={(val) => {
              onChangeCell('FREQ_C', val);
            }}
          ></NumericEntry_inputEx>
        </>
      );
    } else {
      return null;
    }
  };

  /**
   * 裕度
   * @returns
   */
  const band_val_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else if (judgeSet.JDG_TYP !== JdgTypKind.RAW && judgeSet.JDG_TYP !== JdgTypKind.KASHIKA) {
      if (judgeSet.CHANGE_INVALID === 2) {
        //移動平均は裕度不使用
        return null;
      }
      return (
        <>
          <NumericEntry_inputEx
            className={tableBaseStyle.textField}
            value={judgeSet.BAND_VAL}
            fixed={4}
            minValueLimit={0.0000}
            maxValueLimit={10.0000}
            onChange={(val) => {
              onChangeCell('BAND_VAL', val);
            }}
          ></NumericEntry_inputEx>
        </>
      );
    } else {
      return null;
    }
  };

  /**
   * 軽故障
   * @returns
   */
  const wrn_lim_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均は変更不可
      return judgeSet.WRN_LIM.toFixed(4);
    } else {
      return (
        <>
          <NumericEntry_inputEx
            className={tableBaseStyle.textField}
            value={judgeSet.WRN_LIM}
            fixed={4}
            onChange={(val) => {
              onChangeCell('WRN_LIM', val);
            }}
          ></NumericEntry_inputEx>
        </>
      );
    }
  };

  /**
   * 重故障
   * @returns
   */
  const alm_lim_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均は変更不可
      return judgeSet.ALM_LIM.toFixed(4);
    } else {
      return (
        <>
          <NumericEntry_inputEx
            className={tableBaseStyle.textField}
            value={judgeSet.ALM_LIM}
            fixed={4}
            onChange={(val) => {
              onChangeCell('ALM_LIM', val);
            }}
          ></NumericEntry_inputEx>
        </>
      );
    }
  };
  /**
   * 演算方法
   * @returns
   */
  const clc_typ_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else if (judgeSet.CHANGE_INVALID === 1) {
      let clcList = clcFilterFCombos();
      let num = clcList.findIndex((r) => r.index == judgeSet.CLC_TYP);
      if (num === -1) {
        return null;
      } else {
        return <>{clcList[num].name}</>;
      }
    } else if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均は固定表示
      let clcList = clcFilterFCombos();
      let num = clcList.findIndex((r) => r.index == judgeSet.CLC_TYP);
      if (num === -1) {
        return null;
      } else {
        return <>{clcList[num].name}</>;
      }
    } else {
      return (
        <>
          <ItemComboBox
            label=""
            itemList={clcFilterFCombos()}
            value={judgeSet.CLC_TYP}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                const val = parseInt(e.target.value);
                onChangeClcType(val);
              }
            }}
          ></ItemComboBox>
        </>
      );
    }
  };

  /**
   * 異常種別
   * @returns
   */
  const alm_typ_no_disp = () => {
    if (judgeSet.MCLC_TYP_ID === 0) {
      return null;
    } else {
      return (
        <>
          <ItemComboBox
            label=""
            itemList={almFilterCombos()}
            value={judgeSet.ALM_TYP_NO}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                const val = parseInt(e.target.value);
                onChangeCellAutoValue('ALM_TYP_NO', val);
              }
            }}
          ></ItemComboBox>
        </>
      );
    }
  };

  /**
   * 診断タイプ
   * @returns 
   */
  const jdg_type_disp = () => {
    if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均を固定表示
      let clcList = jdgFilterCombos();
      let num = clcList.findIndex((r) => r.index == judgeSet.JDG_TYP);
      if (num === -1) {
        return null;
      } else {
        return <>{clcList[num].name}</>;
      }
    }
    else {
      return (
        <>
          <ItemComboBox
            label=""
            itemList={jdgFilterCombos()}
            value={judgeSet.JDG_TYP}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                const val = parseInt(e.target.value);
                onChangeJogType(val);
              }
            }}
          />
        </>
      );
    }
  };

  /**
   * 演算種別
   * @returns 
   */
  const mclc_typ_id_disp = () => {
    if (judgeSet.CHANGE_INVALID === 2) {
      //移動平均方を固定表示
      let clcList = props.mclcTypeCombos;
      let num = clcList.findIndex((r) => r.index == judgeSet.MCLC_TYP_ID);
      if (num === -1) {
        return null;
      } else {
        return <>{clcList[num].name}</>;
      }
    }
    else {
      return (
        <>
          <ItemComboBox
            label=""
            itemList={mclcTypeFilterCombos()}
            value={judgeSet.MCLC_TYP_ID}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                const val = parseInt(e.target.value);
                onChangemClcType(val);
              }
            }}
          />
        </>
      )
    }
  }

  /**
   * 演算種別変更event
   */
  const onChangemClcType = (value: number) => {
    if (judgeSet.MCLC_TYP_ID === value) {
      return;
    }
    judgeSet.MCLC_TYP_ID = value;

    if (judgeSet.MCLC_TYP_ID === 0) {
      //未設定
      judgeSet.JDG_TYP = 0;
      judgeSet.FREQ_C = 0;
      judgeSet.CLC_TYP = 0;
      judgeSet.BAND_VAL = 0;
      judgeSet.WRN_LIM = 0;
      judgeSet.ALM_LIM = 0;

      judgeSet.HRM_JDG_ON = 0;
      judgeSet.ADJ_ROT_ON = 0;
      judgeSet.EMC_W_POS = 0;
      judgeSet.EMC_B_POS = 0;
      judgeSet.ALM_TYP_NO = 0;
      judgeSet.CHANGE_INVALID = 0;
      judgeSet.F2_CANCEL = 0;
    } else {
      const judgest = props.judgeItemSelectInfo.filter((r) => r.MCLC_TYP_ID === judgeSet.MCLC_TYP_ID);
      if (judgest.length !== 0) {
        judgeSet.JDG_TYP = judgest[0].TYP_NO_JDG;
      } else {
        judgeSet.JDG_TYP = 0;
      }

      //コンボボックスデフォルト設定
      const clcList = props.judgeItemSelectInfo.filter(
        (r) => r.MCLC_TYP_ID === judgeSet.MCLC_TYP_ID && r.TYP_NO_JDG === judgeSet.JDG_TYP
      );
      if (clcList.length !== 0) {
        judgeSet.CLC_TYP = clcList[0].TYP_NO_CLC;
      } else {
        judgeSet.CLC_TYP = 0;
      }

      if (judgeSet.JDG_TYP === JdgTypKind.RAW) {
        //生波形
        judgeSet.FREQ_C = 0;
        judgeSet.BAND_VAL = 0;
        judgeSet.ADJ_ROT_ON = 0;
      } else if (judgeSet.JDG_TYP === JdgTypKind.KASHIKA) {
        //可視化処理2
        judgeSet.BAND_VAL = 0;
        judgeSet.ADJ_ROT_ON = 0;
      }
    }
    onChangeCellAutoValue('MCLC_TYP_ID', value);
  };
  /**
   * 診断タイプ変更event
   */
  const onChangeJogType = (value: number) => {
    if (judgeSet.JDG_TYP === value) {
      return;
    }
    judgeSet.JDG_TYP = value;

    if (judgeSet.JDG_TYP === 0) {
      //未設定
      judgeSet.FREQ_C = 0;
      judgeSet.CLC_TYP = 0;
      judgeSet.BAND_VAL = 0;
      judgeSet.WRN_LIM = 0;
      judgeSet.ALM_LIM = 0;

      judgeSet.HRM_JDG_ON = 0;
      judgeSet.ADJ_ROT_ON = 0;
      judgeSet.EMC_W_POS = 0;
      judgeSet.EMC_B_POS = 0;
      judgeSet.ALM_TYP_NO = 0;
      judgeSet.CHANGE_INVALID = 0;
      judgeSet.F2_CANCEL = 0;
    } else {
      //コンボボックスデフォルト設定
      const clcList = props.judgeItemSelectInfo.filter((r) => r.TYP_NO_JDG === judgeSet.JDG_TYP);
      if (clcList.length !== 0) {
        judgeSet.CLC_TYP = clcList[0].TYP_NO_CLC;
      } else {
        judgeSet.CLC_TYP = 0;
      }

      const almList = props.judgeItemSelectInfo.filter(
        (r) => r.TYP_NO_JDG === judgeSet.JDG_TYP && r.TYP_NO_CLC === judgeSet.CLC_TYP
      );
      if (almList.length !== 0) {
        judgeSet.ALM_TYP_NO = clcList[0].TYP_NO_ALM;
      } else {
        judgeSet.ALM_TYP_NO = 0;
      }

      if (judgeSet.JDG_TYP === JdgTypKind.RAW) {
        //生波形
        judgeSet.FREQ_C = 0;
        judgeSet.BAND_VAL = 0;
        judgeSet.ADJ_ROT_ON = 0;
      } else if (judgeSet.JDG_TYP === JdgTypKind.KASHIKA) {
        //可視化処理2
        judgeSet.BAND_VAL = 0;
        judgeSet.ADJ_ROT_ON = 0;
      }
    }
    onChangeCellAutoValue('JDG_TYP', value);
  };

  /**
   * 演算方法タイプ変更event
   * @param value
   * @returns
   */
  const onChangeClcType = (value: number) => {
    console.debug(['onChangeClcType judgeSet, clcValue', judgeSet, value]);
    if (judgeSet.JDG_TYP === JdgTypKind.RAW) {
      if (value === MeasureClcType.eSpd) {
        //「生波形」，「速度」を選択したとき，「生波形 速度」自動反映
        judgeSet.ALM_TYP_NO = AlmTypKind.eRawSpd;
      }
    }
    if (judgeSet.JDG_TYP === JdgTypKind.RAW) {
      if (value === MeasureClcType.eDsp) {
        //「生波形」，「変位」を選択したとき，「生波形 変位」自動反映
        judgeSet.ALM_TYP_NO = AlmTypKind.eRawDsp;
      }
    }
    onChangeCellAutoValue('CLC_TYP', value);
  };

  //console.debug(['- 画面描画開始 -', props.judgeSettingItem,]);
  return (
    <TableRow key={props.judgeSettingItem.JDG_NO}>
      <TableCell className={tableBaseStyle.bodyCellCenter}>{props.judgeSettingItem.JDG_NO}</TableCell>
      <TableCell className={tableBaseStyle.bodyCellCenter}>
        <Checkbox
          checked={judgeSet.USE_ON === 1 ? true : false}
          onChange={(e) => {
            let v = judgeSet.USE_ON === 1 ? 0 : 1;
            onChangeCell('USE_ON', v);
          }}
        />
      </TableCell>
      {/* 演算種別 */}
      <TableCell className={tableBaseStyle.bodyCellLeft}>{mclc_typ_id_disp()}</TableCell>
      {/* 診断タイプNo. */}
      <TableCell className={tableBaseStyle.bodyCellLeft}>{jdg_type_disp()}</TableCell>
      {/* 周波数 */}
      <TableCell className={tableBaseStyle.bodyCellRight}>{freq_c_disp()}</TableCell>
      {/* 裕度 */}
      <TableCell className={tableBaseStyle.bodyCellRight}>{band_val_disp()}</TableCell>
      {/* 演算方法 */}
      <TableCell className={tableBaseStyle.bodyCell}>{clc_typ_disp()}</TableCell>
      {/* 軽故障 */}
      <TableCell className={tableBaseStyle.bodyCellRight}>{wrn_lim_disp()}</TableCell>
      {/* 重故障 */}
      <TableCell className={tableBaseStyle.bodyCellRight}>{alm_lim_disp()}</TableCell>

      {/* 高調波判定実行 */}
      <TableCell className={tableBaseStyle.bodyCellCenter}>
        {judgeSet.JDG_TYP > 0 ? (
          <Checkbox
            checked={judgeSet.HRM_JDG_ON === 1 ? true : false}
            disabled={judgeSet.CHANGE_INVALID === 2} //移動平均はチェックボックスをクリックしても変わらないようにする
            onChange={(e) => {
              let v = judgeSet.HRM_JDG_ON === 1 ? 0 : 1;
              onChangeCell('HRM_JDG_ON', v);
            }}
          />
        ) : null}
      </TableCell>
      {/**2fキャンセル */}
      <TableCell className={tableBaseStyle.bodyCellCenter}>
        {judgeSet.JDG_TYP > 0 ? (
          <Checkbox
            checked={judgeSet.F2_CANCEL === 1 ? true : false}
            disabled={judgeSet.CHANGE_INVALID === 2} //移動平均はチェックボックスをクリックしても変わらないようにする
            onChange={(e) => {
              let v = judgeSet.F2_CANCEL === 1 ? 0 : 1;
              onChangeCell('F2_CANCEL', v);
            }}
          />
        ) : null}
      </TableCell>
      {/**異常内容 */}
      <TableCell className={tableBaseStyle.bodyCell}>{alm_typ_no_disp()}</TableCell>
    </TableRow>
  );
};

export default JudgeSettingItemRow;
